const Transparency = ["Clear", "Slightly Turbid", "Turbid"];

export default Transparency;
